module.exports = __webpack_public_path__ + "ad6f18b8f074344c238b1611a1ead946.png";